import Swiper from 'swiper';
import VideoPlayer from '../VideoPlayer';

// Styles
import 'swiper/dist/css/swiper.min.css';

export default class CategorySlider {
  // html selector for the component
  // html selector for the component
  static selectorString() {
    return '.js-category-slider';
  }

  // rootNode = html element with js-class
  // props = data attribute 'props' to pass down customization
  constructor(rootNode, props) {
    CategorySlider.nav = rootNode.querySelector('.js-category-slider-nav');
    CategorySlider.slider = rootNode.querySelector('.swiper-wrapper');
    CategorySlider.videos = rootNode.querySelectorAll('.video-js');

    // Params
    const sliderSelector = rootNode.querySelector('.swiper-container');
    const options = {
      init: false,
      loop: false,
      speed: 1000,
      effect: 'coverflow',
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      clickable: false,
      initialSlide: 2,
      coverflowEffect: {
        rotate: 0,
        stretch: 370,
        depth: 200,
        modifier: 1,
        slideShadows: true,
      },
      pagination: false,
      navigation: false,
    };

    CategorySlider.swiper = new Swiper(sliderSelector, options);

    CategorySlider.swiper.on('beforeInit', function () {
      rootNode.classList.add('active');
    });

    CategorySlider.swiper.on('slideChange', function (e) {
      CategorySlider.setActiveTab(CategorySlider.swiper.activeIndex + 1);
    });

    CategorySlider.swiper.on('sliderMove', function (e) {
      CategorySlider.stopAllVideos();
    });

    CategorySlider.swiper.on('slideChangeTransitionStart', function (e) {
      CategorySlider.playVideo(CategorySlider.swiper.activeIndex + 1);
    });

    CategorySlider.swiper.on('touchEnd', function (e) {
      CategorySlider.playVideo(CategorySlider.swiper.activeIndex + 1);
    });

    CategorySlider.swiper.init();

    CategorySlider.setEvents();
  }

  /**
   * Set events
   */
  static setEvents() {
    const navButtons = CategorySlider.nav.querySelectorAll('.nav-item');

    navButtons.forEach(function (v, k) {
      v.onclick = function () {
        const index = v.getAttribute('data-index');
        CategorySlider.setActiveTab(index);
        CategorySlider.swiper.slideTo(index - 1);
      };
    });
  }

  /**
   * Set active tab
   * @param index
   */
  static setActiveTab(index) {
    const navButtons = CategorySlider.nav.querySelectorAll('.nav-item');

    navButtons.forEach(function (v, k) {
      v.classList.remove('active');
    });

    CategorySlider.nav.querySelector('.nav-item[data-index="' + index + '"]').classList.add('active');
  }

  /**
   * Set active tab
   * @param index
   */
  static playVideo(index) {
    VideoPlayer.playVideo(CategorySlider.slider.querySelector('.swiper-slide[data-index="' + index + '"] .video-js'));
  }

  /**
   * Stop all playing videos
   */
  static stopAllVideos() {
    CategorySlider.videos.forEach(function (v, k) {
      VideoPlayer.stopVideo(v);
    });
  }
}
